const devVotingPortalApiUrl: string = 'https://vp.be.dev.sobrado.ch';
const devSngGatewayApiUrl: string = 'https://gateway.dev.sobrado.ch';
const devSobradoApiUrl: string = 'https://dev.sobrado.ch';

export const environment = {
  name: 'dev',
  production: false,
  publicApiUrl: `${devVotingPortalApiUrl}/api/public`,
  portalApiUrl: `${devVotingPortalApiUrl}`,
  sngGatewayApiUrl: `${devSngGatewayApiUrl}`,
  sharedLinkAuthApiUrl: `${devSobradoApiUrl}/api-platform/generate-guest-jwt`,
  sentry: {
    dsn: 'https://e1233cca559db4353d118472cb579029@o302940.ingest.us.sentry.io/4508992843153408',
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
  },
  matomo: {
    trackerUrl: '',
    siteId: '',
  },
};
